      console.log("GG Giftlist JS loaded ✅");
      /* =========================================================
   INTEREST MAPPING
========================================================= */

const GG_INTEREST_MAP = {
  // Arts & Crafts
  'art': 'Arts & Crafts',
  'arts': 'Arts & Crafts',
  'crafts': 'Arts & Crafts',
  'craft': 'Arts & Crafts',
  'drawing': 'Arts & Crafts',
  'painting': 'Arts & Crafts',
  'colouring': 'Arts & Crafts',
  'coloring': 'Arts & Crafts',
  'stickers': 'Arts & Crafts',
  'making': 'Arts & Crafts',
  'sewing': 'Arts & Crafts',
  'knitting': 'Arts & Crafts',

  // Sport
  'football': 'Sport',
  'soccer': 'Sport',
  'rugby': 'Sport',
  'swimming': 'Sport',
  'gymnastics': 'Sport',
  'dancing': 'Sport',
  'dance': 'Sport',
  'sport': 'Sport',
  'sports': 'Sport',
  'tennis': 'Sport',
  'cycling': 'Sport',
  'running': 'Sport',
  'hockey': 'Sport',
  'netball': 'Sport',
  'basketball': 'Sport',
  'cricket': 'Sport',

  // Nature
  'dinosaurs': 'Nature',
  'dinosaur': 'Nature',
  'dino': 'Nature',
  'animals': 'Nature',
  'animal': 'Nature',
  'bugs': 'Nature',
  'insects': 'Nature',
  'birds': 'Nature',
  'nature': 'Nature',
  'plants': 'Nature',
  'gardening': 'Nature',
  'garden': 'Nature',
  'wildlife': 'Nature',
  'ocean': 'Nature',
  'sea': 'Nature',
  'sharks': 'Nature',
  'horses': 'Nature',
  'horse': 'Nature',
  'cats': 'Nature',
  'dogs': 'Nature',

  // Building & Construction
  'lego': 'Building & Construction',
  'building': 'Building & Construction',
  'blocks': 'Building & Construction',
  'construction': 'Building & Construction',
  'duplo': 'Building & Construction',
  'magnetic': 'Building & Construction',
  'magnetics': 'Building & Construction',

  // Imaginative Play
  'imaginative': 'Imaginative Play',
  'roleplay': 'Imaginative Play',
  'role-play': 'Imaginative Play',
  'dressing': 'Imaginative Play',
  'dolls': 'Imaginative Play',
  'doll': 'Imaginative Play',
  'figures': 'Imaginative Play',
  'playmobil': 'Imaginative Play',
  'pretend': 'Imaginative Play',
  'fairies': 'Imaginative Play',
  'fairy': 'Imaginative Play',
  'princess': 'Imaginative Play',
  'pirates': 'Imaginative Play',
  'superheroes': 'Imaginative Play',
  'superhero': 'Imaginative Play',

  // Reading
  'reading': 'Reading',
  'books': 'Reading',
  'book': 'Reading',
  'stories': 'Reading',
  'story': 'Reading',

  // Music
  'music': 'Music',
  'singing': 'Music',
  'guitar': 'Music',
  'piano': 'Music',
  'drums': 'Music',
  'instruments': 'Music',

  // Science
  'science': 'Science',
  'space': 'Science',
  'planets': 'Science',
  'experiments': 'Science',
  'coding': 'Science',
  'robots': 'Science',
  'robotics': 'Science',
  'stem': 'Science',

  // Gaming
  'gaming': 'Gaming',
  'games': 'Gaming',
  'game': 'Gaming',
  'video games': 'Gaming',
  'minecraft': 'Gaming',

  // Outdoor Play
  'outdoor': 'Outdoor Play',
  'outdoors': 'Outdoor Play',
  'garden': 'Outdoor Play',
  'scooter': 'Outdoor Play',
  'bike': 'Outdoor Play',
  'climbing': 'Outdoor Play',
  'trampoline': 'Outdoor Play',
};

function ggMapInterests(freeText) {
  if (!freeText) return [];

  const words = freeText.toLowerCase().split(/[\s,&+]+/);
  const matched = new Set();

  words.forEach(word => {
    const clean = word.trim().replace(/[^a-z\-]/g, '');
    if (GG_INTEREST_MAP[clean]) {
      matched.add(GG_INTEREST_MAP[clean]);
    }
  });

  return Array.from(matched);
}
/* =========================================================
   BROWSE URL BUILDER
========================================================= */

const GG_AGE_IDS = {
  '0-1 years': 'gid://shopify/Metaobject/480529842553',
  '1-2 years': 'gid://shopify/Metaobject/480529777017',
  '3-4 years': 'gid://shopify/Metaobject/480529711481',
  '5-6 years': 'gid://shopify/Metaobject/480529613177',
  '7-8 years': 'gid://shopify/Metaobject/480529547641',
  '9-10 years': 'gid://shopify/Metaobject/480529514873',
  '11-12 years': 'gid://shopify/Metaobject/480529416569',
  '13-14 years': 'gid://shopify/Metaobject/480529088889',
  '15+ years': 'gid://shopify/Metaobject/480523354489'
};

const GG_INTEREST_IDS = {
  'Active Play':        'gid://shopify/Metaobject/507462713721',
  'Animals':            'gid://shopify/Metaobject/483138503033',
  'Art':                'gid://shopify/Metaobject/494123057529',
  'Arts & Crafts':      'gid://shopify/Metaobject/483138011513',
  'Audio':              'gid://shopify/Metaobject/507447640441',
  'Baby Toys':          'gid://shopify/Metaobject/494121386361',
  'Books':              'gid://shopify/Metaobject/483138240889',
  'Building':           'gid://shopify/Metaobject/483138371961',
  'Collecting':         'gid://shopify/Metaobject/494544683385',
  'Construction':       'gid://shopify/Metaobject/494118470009',
  'Crafts':             'gid://shopify/Metaobject/494123123065',
  'Creative play':      'gid://shopify/Metaobject/507463500153',
  'Creativity':         'gid://shopify/Metaobject/483137585529',
  'Dinosaurs':          'gid://shopify/Metaobject/494121451897',
  'Dolls':              'gid://shopify/Metaobject/494118863225',
  'Dress Up':           'gid://shopify/Metaobject/494122926457',
  'Fairies':            'gid://shopify/Metaobject/494121517433',
  'Fashion':            'gid://shopify/Metaobject/483191357817',
  'Games':              'gid://shopify/Metaobject/483141452153',
  'Harry Potter':       'gid://shopify/Metaobject/494118699385',
  'Imaginative Play':   'gid://shopify/Metaobject/483138273657',
  'Independent play':   'gid://shopify/Metaobject/507447935353',
  'Jewellery':          'gid://shopify/Metaobject/483138929017',
  'Learning':           'gid://shopify/Metaobject/494118273401',
  'Lego':               'gid://shopify/Metaobject/494121550201',
  'Magic':              'gid://shopify/Metaobject/483190407545',
  'Mindfulness':        'gid://shopify/Metaobject/494118437241',
  'Nature':             'gid://shopify/Metaobject/483138470265',
  'Outdoor Games':      'gid://shopify/Metaobject/483141550457',
  'Outdoor play':       'gid://shopify/Metaobject/507463434617',
  'Reading':            'gid://shopify/Metaobject/494118666617',
  'Role Play':          'gid://shopify/Metaobject/494120010105',
  'Science':            'gid://shopify/Metaobject/494119125369',
  'Sensory':            'gid://shopify/Metaobject/494120239481',
  'Space':              'gid://shopify/Metaobject/483138699641',
  'Sport':              'gid://shopify/Metaobject/483137618297',
  'STEM':               'gid://shopify/Metaobject/483137847673',
  'Storytelling':       'gid://shopify/Metaobject/494544879993',
  'Swimming':           'gid://shopify/Metaobject/507462615417',
  'Transport & Vehicles': 'gid://shopify/Metaobject/494119420281'
};

function ggGetAgeAtOccasion(dobString, occasionDateString) {
  const dob = new Date(dobString);
  const occasion = new Date(occasionDateString);
  let age = occasion.getFullYear() - dob.getFullYear();
  const m = occasion.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && occasion.getDate() < dob.getDate())) age--;
  return age;
}

function ggAgeToShopifyBand(age) {
  if (age <= 1)  return '0-1 years';
  if (age <= 2)  return '1-2 years';
  if (age <= 4)  return '3-4 years';
  if (age <= 6)  return '5-6 years';
  if (age <= 8)  return '7-8 years';
  if (age <= 10) return '9-10 years';
  if (age <= 12) return '11-12 years';
  if (age <= 14) return '13-14 years';
  return '15+ years';
}

// Maps our internal interest categories to Shopify interest labels
const GG_INTEREST_CATEGORY_MAP = {
  'Arts & Crafts':          ['Arts & Crafts', 'Crafts', 'Art', 'Creative play'],
  'Sport':                  ['Sport', 'Active Play', 'Outdoor Games'],
  'Nature':                 ['Nature', 'Animals', 'Dinosaurs'],
  'Building & Construction': ['Building', 'Construction', 'Lego'],
  'Imaginative Play':       ['Imaginative Play', 'Role Play', 'Dolls', 'Dress Up', 'Fairies'],
  'Reading':                ['Reading', 'Books', 'Storytelling'],
  'Music':                  ['Audio'],
  'Science':                ['Science', 'STEM', 'Space'],
  'Gaming':                 ['Games'],
  'Outdoor Play':           ['Outdoor play', 'Active Play'],
};

function ggBuildBrowseUrl(occasionTitle) {
  try {
    const meta = JSON.parse(
      localStorage.getItem(`gg_occasion_meta__${occasionTitle}`) || '{}'
    );

    const params = new URLSearchParams();

    // Age filter
    if (meta.child_dob && meta.occasion_date) {
      const age = ggGetAgeAtOccasion(meta.child_dob, meta.occasion_date);
      const band = ggAgeToShopifyBand(age);
      const ageId = GG_AGE_IDS[band];
      if (ageId) {
        params.append('filter.p.m.custom.age', ageId);
      }
    }

    // Interest filters
    if (meta.child_interests_mapped && meta.child_interests_mapped.length) {
      meta.child_interests_mapped.forEach(category => {
        const shopifyLabels = GG_INTEREST_CATEGORY_MAP[category] || [];
        shopifyLabels.forEach(label => {
          const id = GG_INTEREST_IDS[label];
          if (id) {
            params.append('filter.p.m.custom.interests_range', id);
          }
        });
      });
    }

    const query = params.toString();
    return `/collections/all${query ? '?' + query : ''}`;

  } catch (e) {
    console.warn('ggBuildBrowseUrl failed', e);
    return '/collections/all';
  }
}
      /* =========================================================
   HELPERS
========================================================= */

function formatOccasionName(name) {
  if (!name) return "";

  if (name.includes("’s") || name.includes("'s")) return name;

  return name.replace(/s(\s|$)/, "’s$1");
}
      
      /* Good Gifts – Gift List (Phase 1: guest/localStorage) */

      (function () {
      const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M";
      const SUPABASE_URL = "https://uxqpmqluozqnytnqhnwt.supabase.co";

      // ===== Occasion list storage (each occasion gets its own list) =====
      const STORAGE_KEY_PREFIX = "gg_giftlist_v1__";

window.syncListsFromCustomer = async function () {
        const customerId = window.ggCustomer?.id;
        if (!customerId) return;

        const GG_KEY =
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M";

        try {
          const res = await fetch(
            `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-lists-by-customer?customer_id=${encodeURIComponent(customerId)}`,
            {
              headers: {
                apikey: GG_KEY,
                Authorization: `Bearer ${GG_KEY}`
              }
            }
          );

          const data = await res.json();
          const lists = Array.isArray(data?.lists) ? data.lists : [];

          // Titles the user has explicitly deleted — never restore these.
          let deletedOccasions = [];
          try {
            deletedOccasions = JSON.parse(
              localStorage.getItem("gg_deleted_occasions_v1") || "[]"
            );
          } catch (e) {
            deletedOccasions = [];
          }

          // Only sync lists that haven't been explicitly deleted.
          const filteredLists = lists.filter(
            (l) =>
              !deletedOccasions.includes(
                (l.title || "").replace(/[‘’]/g, "'")
              )
          );

          // Restore each server list into local storage (additive — never wipes).
          filteredLists.forEach((list) => {
            const title = (list.title || "My Gift Ideas").replace(/[‘’]/g, "'");
            const items = Array.isArray(list.items) ? list.items : [];
            const localKey = `gg_giftlist_v1__${title}`;

            if (items.length > 0) {
              let existingItems = [];
              try {
                const raw = localStorage.getItem(localKey);
                existingItems = raw ? JSON.parse(raw) : [];
              } catch (e) {
                existingItems = [];
              }
              if (!Array.isArray(existingItems)) existingItems = [];

              // Merge server + local items, de-duplicated by id.
              const merged = [...items];
              existingItems.forEach((localItem) => {
                if (!merged.some((x) => String(x.id) === String(localItem.id))) {
                  merged.push(localItem);
                }
              });
              localStorage.setItem(localKey, JSON.stringify(merged));
            } else if (localStorage.getItem(localKey) === null) {
              localStorage.setItem(localKey, "[]");
            }

            if (list.share_code) localStorage.setItem(`gg_share_code__${title}`, list.share_code);
            if (list.owner_token) localStorage.setItem(`gg_owner_token__${title}`, list.owner_token);
            if (list.id) localStorage.setItem(`gg_list_id__${title}`, list.id);

            const meta = {
              child_name: list.child_name || null,
              child_dob: list.child_dob || null,
              child_pronoun: list.child_pronoun || "they",
              child_interests: list.child_interests || null,
              child_note: list.child_note || null,
              occasion_type: list.occasion_type || "",
              occasion_date: list.occasion_date || list.event_date || null
            };
            localStorage.setItem(`gg_occasion_meta__${title}`, JSON.stringify(meta));
          });

          // Merge occasion names: existing local + synced, minus deleted.
          let existingOccasions = [];
          try {
            existingOccasions = JSON.parse(
              localStorage.getItem("gg_occasions_v1") || "[]"
            );
          } catch (e) {
            existingOccasions = [];
          }
          if (!Array.isArray(existingOccasions)) existingOccasions = [];

          const syncedTitles = filteredLists
            .map((l) => (l.title || "").replace(/[‘’]/g, "'"))
            .filter(Boolean);

          const finalOccasions = [
            ...new Set(
              [...existingOccasions, ...syncedTitles]
                .map((n) => n.replace(/[‘’]/g, "'"))
                .filter((n) => !deletedOccasions.includes(n))
            )
          ];
          localStorage.setItem("gg_occasions_v1", JSON.stringify(finalOccasions));

          // Normalise any curly-apostrophe list keys to straight apostrophes.
          Object.keys(localStorage)
            .filter((k) => k.includes("’"))
            .forEach((k) => {
              try {
                const normalKey = k.replace(/[‘’]/g, "'");
                let curlyItems = [];
                let straightItems = [];
                try { curlyItems = JSON.parse(localStorage.getItem(k)) || []; } catch (e) {}
                try { straightItems = JSON.parse(localStorage.getItem(normalKey)) || []; } catch (e) {}
                if (
                  Array.isArray(curlyItems) &&
                  Array.isArray(straightItems) &&
                  curlyItems.length > straightItems.length
                ) {
                  localStorage.setItem(normalKey, JSON.stringify(curlyItems));
                }
                localStorage.removeItem(k);
              } catch (e) {}
            });

          // Set an active occasion only if none is set yet.
          const currentActive = localStorage.getItem("gg_active_occasion_v1");
          if (!currentActive && finalOccasions[0]) {
            localStorage.setItem("gg_active_occasion_v1", finalOccasions[0]);
          }

          console.log(`Synced ${filteredLists.length} list(s) from customer account`);

          if (window.ggRenderOccasionsFromStorage) {
            window.ggRenderOccasionsFromStorage();
          }
        } catch (err) {
          console.log("Could not sync lists from customer account", err);
        }
      };

// Run on page load
document.addEventListener("DOMContentLoaded", function () {
  syncListsFromCustomer();
});

      window.ggGetActiveOccasionName = function () {
        return (localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas").trim();
      };
      function ggListKeyForOccasion(name) {
        return STORAGE_KEY_PREFIX + String(name || "My Gift Ideas").trim();
      }
        function readList() {
        try {
          const key = ggListKeyForOccasion(ggGetActiveOccasionName());
          const raw = localStorage.getItem(key);
          return raw ? JSON.parse(raw) : [];
        } catch (e) {
          return [];
        }
      }

        function writeList(items) {
        const key = ggListKeyForOccasion(ggGetActiveOccasionName());
        localStorage.setItem(key, JSON.stringify(items));
      }

      function isInList(id) {
        try {
          const prefix = STORAGE_KEY_PREFIX;

          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!key || !key.startsWith(prefix)) continue;

            const raw = localStorage.getItem(key);
            if (!raw) continue;

            const items = JSON.parse(raw);
            if (!Array.isArray(items)) continue;

            if (items.some((x) => String(x.id) === String(id))) {
              return true;
            }
          }
        } catch (e) {
          console.warn("Good Gifts: failed to check saved heart state", e);
        }

        return false;
      }

        function addItem(item) {
          const items = readList();
          if (!items.some((x) => String(x.id) === String(item.id))) {
            items.unshift(item);
            writeList(items);
          }
        }

        function removeItem(id) {
        const items = readList().filter(x => String(x.id) !== String(id));
        writeList(items);
        // Direct targeted save - preserves purchased states of remaining items
        (async function() {
          try {
            const activeOccasion = localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas";
            const shareCode = localStorage.getItem(`gg_share_code__${activeOccasion}`) || localStorage.getItem('gg_share_code');
            if (!shareCode) return;

            // Get current list from Supabase to preserve all states
            const getRes = await fetch(
              `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(shareCode)}`,
              { headers: { apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M", Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M` } }
            );
            const getData = await getRes.json();
            const payload = getData?.list || getData || {};
            let remoteItems = payload.items || [];
            if (typeof remoteItems === 'string') { try { remoteItems = JSON.parse(remoteItems); } catch(e) { remoteItems = []; } }

            // Remove the item but keep all purchased states intact
            const updatedItems = remoteItems
              .filter(i => String(i.id) !== String(id))
              .map(i => ({
                id: String(i.id || ""),
                title: i.title || "",
                url: i.url || "",
                image: i.image || "",
                price: i.price || "",
                handle: i.handle || "",
                purchased: !!i.purchased
              }));

            const savedMeta = (() => { try { return JSON.parse(localStorage.getItem(`gg_occasion_meta__${activeOccasion}`) || "{}"); } catch { return {}; } })();

            await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
                Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M`
              },
              body: JSON.stringify({
                title: activeOccasion.replace(/[\u2018\u2019]/g, "'"),
                event_date: savedMeta.occasion_date || null,
                occasion_type: savedMeta.occasion_type || "",
                occasion_date: savedMeta.occasion_date || null,
                items: updatedItems,
                child_name: savedMeta.child_name || null,
                child_dob: savedMeta.child_dob || null,
                child_pronoun: savedMeta.child_pronoun || "they",
                child_interests: savedMeta.child_interests || null,
                child_note: savedMeta.child_note || null,
                list_id: localStorage.getItem(`gg_list_id__${activeOccasion}`) || null,
                share_code: localStorage.getItem(`gg_share_code__${activeOccasion}`) || null,
                owner_token: localStorage.getItem(`gg_owner_token__${activeOccasion}`) || null,
                owner_customer_id: window.ggCustomer?.id || null,
                owner_email: window.ggCustomer?.email || null
              })
            });
          } catch(err) {
            console.log("Direct remove save failed", err);
          }
        })();

        const activeOccasion = localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas";
        if (typeof ggToast === "function") {
          ggToast(`Removed from ${activeOccasion}`, "success");
        }
      }

        function toggleItem(item) {
          if (isInList(item.id)) {
            removeItem(item.id);
            return false;
          } else {
            addItem(item);
            return true;
          }
        }

      function updateAllHeartStates() {
        document.querySelectorAll("[data-gg-heart]").forEach((btn) => {

          const id = btn.getAttribute("data-product-id");
          const active = isInList(id);

          btn.classList.toggle("is-active", active);
          btn.setAttribute("aria-pressed", active ? "true" : "false");

          const labelEl = btn.querySelector(".gg-add-to-list__label");
          const defaultLabel = btn.getAttribute("data-default-label");
          const addedLabel = btn.getAttribute("data-added-label");

          if (labelEl && defaultLabel && addedLabel) {
            labelEl.textContent = active ? addedLabel : defaultLabel;
          }

        });
      }


      // Handle heart clicks anywhere on the page
      document.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-gg-heart]");
        if (!btn) return;

        e.preventDefault();

        const item = {
          id: btn.getAttribute("data-product-id"),
          handle: btn.getAttribute("data-product-handle"),
          title: btn.getAttribute("data-product-title"),
          url: btn.getAttribute("data-product-url"),
          image: btn.getAttribute("data-product-image"),
          price: btn.getAttribute("data-product-price"),
          addedAt: new Date().toISOString(),
        };

          // open the modal if it exists
        if (typeof window.ggOpenAddToOccasionModal === "function") {
          window.ggLastHeartBtn = btn;
          window.ggOpenAddToOccasionModal(item);
          return;
        }

        // fallback behaviour
        toggleItem(item);
        if (window.saveListToCustomer) {
        window.saveListToCustomer();
        }
        updateAllHeartStates();

        if (document.querySelector("[data-gg-giftlist-page]")) {
        renderGiftListPage();
      }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }
      });

        /* =========================================================
        REMOVE ITEM FROM LIST
      ========================================================= */

      document.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-gg-remove]");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const id = btn.getAttribute("data-product-id");
        if (!id) return;

        removeItem(id);
        updateAllHeartStates();

        if (document.querySelector("[data-gg-giftlist-page]")) {
          // Remove just this card from the DOM instead of full re-render
          const card = document.querySelector(`.gg-giftlist-card[data-item-id="${id}"]`);
          if (card) card.remove();

          // If no cards left, do a full render to show empty state
          const remaining = document.querySelectorAll('.gg-giftlist-card');
          if (!remaining.length) {
            renderGiftListPage();
          }
        }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }

        ggToast("Removed from list", "success");
      });



        function escapeHtml(str) {
          return String(str || "")
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
        }

        function moneyText(price) {
          if (!price) return "";
          return escapeHtml(price);
        }

        window.ggPurchasedCache = new Set();
        window.ggPurchasedCacheLoaded = false;
  async function renderGiftListPage() {
  const root = document.querySelector("[data-gg-giftlist-root]");
  if (!root) return;

  const items = readList();

  if (!items.length) {
    root.innerHTML = `
      <div class="gg-giftlist-empty gg-giftlist-empty--premium">
        <div class="gg-giftlist-empty__inner">
          <p class="gg-giftlist-empty__title"><strong>Start your gift ideas list</strong></p>
          <p class="gg-giftlist-empty__text">
            Browse products and tap the 
            <span class="gg-inline-heart">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41.81 4.5 2.09C12.09 4.81 13.76 4 15.5 4 18 4 20 6 20 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.9"
                      stroke-linejoin="round"/>
              </svg>
            </span>
            to save them here.
          </p>
          <div class="gg-giftlist-empty__actions">
            <a class="gg-giftlist-cta" href="${ggBuildBrowseUrl(ggGetActiveOccasionName())}">Start exploring</a>
          </div>
        </div>
      </div>
    `;
    return;
  }

const purchasedIds = window.ggPurchasedCache || new Set();

  const cards = items
    .map((item) => {
      const img = item.image
        ? `<img class="gg-giftlist-img" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
        : `<div class="gg-giftlist-img gg-giftlist-img--placeholder"></div>`;

      const isPurchased = purchasedIds.has(String(item.id));

      const chosenTag = isPurchased
        ? `<div class="gg-gift-chosen-tag">Gift chosen</div>`
        : '';

      return `
        <div class="gg-giftlist-card ${isPurchased ? 'is-purchased' : ''}" data-item-id="${escapeHtml(item.id)}">
          <a class="gg-giftlist-link" href="${escapeHtml(item.url)}">
            <div style="position:relative">
              ${img}
              ${chosenTag}
            </div>
            <div class="gg-giftlist-meta">
              <div class="gg-giftlist-title">${escapeHtml(item.title)}</div>
              ${item.price ? `<div class="gg-giftlist-price">${moneyText(item.price)}</div>` : ''}
            </div>
          </a>
          <button
            class="gg-giftlist-remove"
            type="button"
            data-gg-remove
            aria-label="Remove from gift ideas"
            data-product-id="${escapeHtml(item.id)}"
            data-product-handle="${escapeHtml(item.handle)}"
            data-product-title="${escapeHtml(item.title)}"
            data-product-url="${escapeHtml(item.url)}"
            data-product-image="${escapeHtml(item.image)}"
            data-product-price="${escapeHtml(item.price)}"
          >
            Remove
          </button>
        </div>
      `;
    })
    .join('');

  root.innerHTML = `
    <div class="gg-giftlist-grid">
      ${cards}
    </div>
    <div class="gg-giftlist-explore">
      <p>Looking for more ideas?</p>
      <a class="gg-giftlist-cta" href="${ggBuildBrowseUrl(ggGetActiveOccasionName())}">Keep exploring</a>
    </div>
  `;
}

        // Make render available for refresh
      window.renderGiftListPage = renderGiftListPage;
      window.ggUpdateAllHeartStates = updateAllHeartStates;

// On page load: set hearts + render list page if present
        document.addEventListener("DOMContentLoaded", async function () {
          updateAllHeartStates();
          if (document.querySelector("[data-gg-giftlist-page]")) {
            // Fetch purchased states ONCE before first render
            try {
              const activeOccasion = ggGetActiveOccasionName();
              const shareCode = localStorage.getItem(`gg_share_code__${activeOccasion}`) ||
                                localStorage.getItem('gg_share_code');
              if (shareCode) {
                const res = await fetch(
                  `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(shareCode)}`,
                  {
                    headers: {
                      apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
                      Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M`
                    }
                  }
                );
                const data = await res.json();
                const payload = data?.list || data || {};
                let remoteItems = payload.items || [];
                if (typeof remoteItems === 'string') {
                  try { remoteItems = JSON.parse(remoteItems); } catch(e) { remoteItems = []; }
                }
                if (Array.isArray(remoteItems)) {
                  window.ggPurchasedCache = new Set();
                  remoteItems.forEach(function(item) {
                    if (item.purchased) window.ggPurchasedCache.add(String(item.id));
                  });
                  window.ggPurchasedCacheLoaded = true;
                }
              }
            } catch(e) {
              console.log('Could not pre-fetch purchased states', e);
            }
            renderGiftListPage();
          }
        });

        // Also update after theme sections load dynamically
        document.addEventListener("shopify:section:load", function () {
          updateAllHeartStates();
        });
      })();
      /* =========================================================
        TOAST + SAVE LIST (clean version)
      ========================================================= */

      function ggToast(message, type = "success") {
        const el =
          document.querySelector("[data-gg-save-message]") ||
          document.querySelector("[data-gg-toast]");

        if (!el) {
          console.log("TOAST:", message);
          return;
        }

        el.textContent = message;
        el.hidden = false;
        el.classList.remove("hidden");
        el.classList.remove("is-success", "is-error");

        if (type === "error") el.classList.add("is-error");
        if (type === "success") el.classList.add("is-success");

        clearTimeout(window.__GG_TOAST_TIMER__);
        window.__GG_TOAST_TIMER__ = setTimeout(() => {
          el.hidden = true;
          el.classList.add("hidden");
          el.classList.remove("is-success", "is-error");
        }, 4500);
      }

      (function () {
        if (window.__GG_GIFTLIST_SAVE_INIT__) return;
        window.__GG_GIFTLIST_SAVE_INIT__ = true;

        const STORAGE_KEY_PREFIX = "gg_giftlist_v1__";

        function safeJsonParse(text) {
          try {
            return JSON.parse(text);
          } catch (e) {
            return null;
          }
        }

        function getActiveOccasionName() {
          try {
            return (localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas").trim();
          } catch (e) {
            return "My Gift Ideas";
          }
        }

        function readActiveList() {
          try {
            const occasion = getActiveOccasionName();
            const key = STORAGE_KEY_PREFIX + occasion;
            const raw = localStorage.getItem(key);
            const items = raw ? JSON.parse(raw) : [];
            return Array.isArray(items) ? items : [];
          } catch (e) {
            return [];
          }
        }

        window.saveListToCustomer = async function () {
          console.log("Running saveListToCustomer()...");

          const activeOccasion = getActiveOccasionName();
          const items = readActiveList();

          console.log("Saving occasion:", activeOccasion);
          console.log("Items being saved:", items);

          if (!items.length) {
            ggToast("Add a few gift ideas first", "error");
            return null;
          }

          const FUNCTION_URL =
  "https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list";

const btn = document.querySelector("[data-gg-save-list]");
if (btn) {
  btn.disabled = true;
  btn.setAttribute("aria-busy", "true");
}

ggToast("Saving…");

const existingShareCode =
  localStorage.getItem(`gg_share_code__${activeOccasion}`) || "";

let remotePurchasedMap = new Map();
// Seed from local cache first so purchased states are never lost
if (window.ggPurchasedCache) {
  window.ggPurchasedCache.forEach(function(id) {
    remotePurchasedMap.set(id, true);
  });
}

if (existingShareCode) {
  try {
    const existingRes = await fetch(
      `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(existingShareCode)}`,
      {
        headers: {
          apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
          Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`
        }
      }
    );

    const existingData = await existingRes.json();
    const existingPayload = existingData?.list || existingData || {};

    let existingItems = existingPayload.items || [];

    if (typeof existingItems === "string") {
      try {
        existingItems = JSON.parse(existingItems);
      } catch (e) {
        existingItems = [];
      }
    }

    (Array.isArray(existingItems) ? existingItems : []).forEach((item) => {
      // Only update if Supabase says purchased, or cache doesn't already have it as purchased
      const id = String(item.id || "");
      if (item.purchased || !remotePurchasedMap.get(id)) {
        remotePurchasedMap.set(id, !!item.purchased);
      }
    });
  } catch (err) {
    console.log("Could not load existing list before save", err);
  }
}

const cleanItems = (items || [])
  .map((item) => ({
    id: String(item.id || ""),
    title: item.title || "",
    url: item.url || "",
    image: item.image || "",
    price: item.price || "",
    handle: item.handle || "",
    purchased:
      typeof item.purchased !== "undefined"
        ? !!item.purchased
        : !!remotePurchasedMap.get(String(item.id || ""))
  }))
  .filter((item) => item.id && item.title && item.url);

console.log("Clean items being saved:", cleanItems);

const savedMeta = (() => {
  try {
    return JSON.parse(localStorage.getItem(`gg_occasion_meta__${activeOccasion}`) || "{}");
  } catch (err) {
    return {};
  }
})();

try {
  const res = await fetch(FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
          },
    body: JSON.stringify({
      title: activeOccasion.replace(/[\u2018\u2019]/g, "'"),
      event_date: savedMeta.occasion_date || null,
      occasion_type: savedMeta.occasion_type || "",
      occasion_date: savedMeta.occasion_date || null,
      items: cleanItems,
      child_name: savedMeta.child_name || null,
      child_dob: savedMeta.child_dob || null,
      child_pronoun: savedMeta.child_pronoun || "they",
      child_interests: savedMeta.child_interests || null,
      child_note: savedMeta.child_note || null,
      list_id: localStorage.getItem(`gg_list_id__${activeOccasion}`) || null,
      share_code: localStorage.getItem(`gg_share_code__${activeOccasion}`) || null,
      owner_token: localStorage.getItem(`gg_owner_token__${activeOccasion}`) || null,
      owner_customer_id: window.ggCustomer?.id || null,
      owner_email: window.ggCustomer?.email || null
    }),
  });

  console.log("Response status:", res.status);

  const raw = await res.text();
  console.log("Raw response:", raw);

  const data = safeJsonParse(raw);

  if (!res.ok) {
  ggToast("Save failed", "error");
  return null;
}

  if (res.ok && data && (data.share_code || data.id)) {
    localStorage.setItem("gg_list_id", data.id);
    localStorage.setItem("gg_owner_token", data.owner_token || "");
    localStorage.setItem("gg_share_code", data.share_code || "");

    localStorage.setItem(`gg_list_id__${activeOccasion}`, data.id);
    localStorage.setItem(`gg_owner_token__${activeOccasion}`, data.owner_token || "");
    localStorage.setItem(`gg_share_code__${activeOccasion}`, data.share_code || "");

    console.log("Save success ✅", data);
    localStorage.setItem("gg_last_saved_items", JSON.stringify(cleanItems));
    ggToast("List saved ✓", "success");
    return data;

   
  } else {
  console.log("Save failed ❌", data);
  ggToast("Save failed", "error");
  return null;
}
} catch (err) {
  console.log("Save error ❌", err);
  ggToast("Save failed", "error");
  return null;
} finally {
  if (btn) {
    btn.disabled = false;
    btn.removeAttribute("aria-busy");
  }
}
        };
        

        document.addEventListener("click", function (e) {
          const btn = e.target.closest("[data-gg-save-list]");
          if (!btn) return;

          e.preventDefault();
          e.stopPropagation();

          console.log("Save list clicked ✅");
          window.saveListToCustomer();
        });
      })();
      /* =========================================================
        OCCASIONS (simple v1: create + persist + highlight)
      ========================================================= */

      const GG_OCCASIONS_KEY = "gg_occasions_v1";
      const GG_ACTIVE_OCCASION_KEY = "gg_active_occasion_v1";

     function ggCountGiftsForOccasion(name) {
  try {
    // Try both straight and curly apostrophes
    const baseName = String(name || "My Gift Ideas").trim();
    const key1 = "gg_giftlist_v1__" + baseName;
    const key2 = "gg_giftlist_v1__" + baseName.replace(/'/g, "\u2019");
    
    const raw = localStorage.getItem(key1) || localStorage.getItem(key2);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.length : 0;
  } catch (e) {
    return 0;
  }
}
      function ggLoadOccasions() {
        try {
          const raw = localStorage.getItem(GG_OCCASIONS_KEY);
          if (!raw) return [];
          const data = JSON.parse(raw);
          return Array.isArray(data) ? data : [];
        } catch {
          return [];
        }
      }

      function ggSaveOccasions(list) {
        localStorage.setItem(GG_OCCASIONS_KEY, JSON.stringify(list));
      }

      function ggLoadActiveOccasion() {
        try {
          return localStorage.getItem(GG_ACTIVE_OCCASION_KEY) || "";
        } catch {
          return "";
        }
      }

      function ggSaveActiveOccasion(name) {
        try {
          localStorage.setItem(GG_ACTIVE_OCCASION_KEY, name);
        } catch {}
      }

      function ggEscapeHtml(str = "") {
        return String(str).replace(/[&<>"']/g, (s) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        }[s]));
      }

      function ggRenderOccasionsFromStorage() {
        console.log("Rendering occasions…");

        const row = document.querySelector("[data-gg-occasions]");
        if (!row) return;

        const active = ggLoadActiveOccasion();

        const occasions = ggLoadOccasions().sort((a, b) => {
          if (a === active) return -1;
          if (b === active) return 1;
          return 0;
        });

        row.innerHTML = "";

        occasions.forEach((name) => {
          const wrap = document.createElement("div");
          wrap.className = "gg-occasion-card-wrap";

          wrap.innerHTML = `
        <div
          class="gg-occasion-card${name === active ? " is-active" : ""}"
          role="button"
          tabindex="0"
          data-gg-occasion-select="${ggEscapeHtml(name)}"
        >
          <p class="gg-occasion-card__name">${ggEscapeHtml(name)}</p>

          <p class="gg-occasion-card__date">
            ${typeof ggGetOccasionDate === "function" ? ggGetOccasionDate(name) : ""}
          </p>

          <p class="gg-occasion-card__meta">
            ${ggCountGiftsForOccasion(name)} gift ideas
          </p>
        </div>

        <button
        type="button"
        class="gg-occasion-card__share"
        data-gg-occasion-share="${ggEscapeHtml(name)}"
      >
        Share gift ideas
      </button>


<div class="gg-occasion-card__actions" aria-hidden="true">
  <button
    type="button"
    class="gg-occasion-card__action"
    data-gg-occasion-edit="${ggEscapeHtml(name)}"
  >
    Edit
  </button>

  <button
    type="button"
    class="gg-occasion-card__action gg-occasion-card__action--delete"
    data-gg-occasion-delete="${ggEscapeHtml(name)}"
  >
    Delete
  </button>
</div>
      `;
          const selectBtn = wrap.querySelector("[data-gg-occasion-select]");

          selectBtn.addEventListener("click", (e) => {
        if (
  e.target.closest(".gg-occasion-card__share") ||
  e.target.closest(".gg-occasion-card__actions") ||
  e.target.closest("[data-gg-occasion-edit]") ||
  e.target.closest("[data-gg-occasion-delete]")
) {
  return;
}

        console.log("Clicked occasion:", name);
        ggSaveActiveOccasion(name);
        ggRenderOccasionsFromStorage();

        if (window.renderGiftListPage) window.renderGiftListPage();
      });

          row.appendChild(wrap);
        });
      }
      window.ggRenderOccasionsFromStorage = ggRenderOccasionsFromStorage;

      /* Create occasion button */
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-gg-create-occasion]");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const name = window.prompt("Occasion name (e.g. Mia’s 6th Birthday):");
  if (!name) return;

  const trimmed = name.trim();
  if (!trimmed) return;

  const occasions = ggLoadOccasions();

  if (occasions.includes(trimmed)) {
    if (typeof ggToast === "function") {
      ggToast("That occasion already exists.", "error");
    }
    return;
  }

  occasions.unshift(trimmed);
  ggSaveOccasions(occasions);
  ggSaveActiveOccasion(trimmed);

  if (!localStorage.getItem("gg_giftlist_v1__" + trimmed)) {
    localStorage.setItem("gg_giftlist_v1__" + trimmed, "[]");
  }

  ggRenderOccasionsFromStorage();

  if (typeof renderGiftListPage === "function") {
    renderGiftListPage();
  }

  if (typeof ggToast === "function") {
    ggToast(`Created ${trimmed}`, "success");
  }
});

      /* Load occasions on page load */
      document.addEventListener("DOMContentLoaded", () => {
        ggRenderOccasionsFromStorage();
      });
         /* =========================================================
      Add to Occasion Modal
    ========================================================= */

    (function () {

      let pendingItem = null;

      function ggOpenModal(item) {
        const modal = document.querySelector("[data-gg-modal]");
        const list = document.querySelector("[data-gg-modal-options]");

          if (!modal || !list) return;

          pendingItem = item;
          const createForm = document.querySelector("[data-gg-modal-create-form]");
      const createInput = document.querySelector("[data-gg-modal-create-input]");
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");

      if (createForm) createForm.hidden = true;
      if (createInput) createInput.value = "";
      if (confirmBox) confirmBox.hidden = true;

          const activeOccasion = ggLoadActiveOccasion();

      const occasions = ggLoadOccasions().sort((a, b) => {
        if (a === activeOccasion) return -1;
        if (b === activeOccasion) return 1;
        return 0;
      });

          list.innerHTML = "";

          occasions.forEach((name) => {

      const row = document.createElement("div");
      row.className = "gg-modal__option";

      row.innerHTML = `
        <button
          type="button"
          class="gg-modal__choose"
          data-gg-occasion-choose="${escapeHtml(name)}"
          aria-label="Choose ${escapeHtml(name)}"
        >
          <div class="gg-modal__option-text">
            <div class="gg-modal__option-name-row">
              <div class="gg-modal__option-name">${escapeHtml(name)}</div>
              ${name === ggLoadActiveOccasion() ? `<span class="gg-modal__option-check">✓</span>` : ""}
            </div>
            <div class="gg-modal__option-meta">${ggCountGiftsForOccasion(name)} gifts</div>
          </div>
        </button>

      `;

      const chooseBtn = row.querySelector("[data-gg-occasion-choose]");

      chooseBtn.addEventListener("click", () => {
        ggSaveActiveOccasion(name);
        ggAddItemToOccasion(item, name);
        ggCloseModal();

        document
          .querySelectorAll(`[data-gg-heart][data-product-id="${item.id}"]`)
          .forEach((heartBtn) => {
            heartBtn.classList.add("is-active");
            heartBtn.setAttribute("aria-pressed", "true");
          });
      });

      list.appendChild(row);

          });


          modal.hidden = false;
        }

      function ggCloseModal() {
        const modal = document.querySelector("[data-gg-modal]");
        if (!modal) return;

        const confirmBox = document.querySelector("[data-gg-modal-confirm]");
        if (confirmBox) confirmBox.hidden = true;

        modal.hidden = true;
        document.body.classList.remove("overflow-hidden");
        pendingItem = null;
      }
      window.ggOpenAddToOccasionModal = ggOpenModal;
      window.ggCloseAddToOccasionModal = ggCloseModal;

        function ggAddItemToOccasion(item, occasionName) {
  const key = "gg_giftlist_v1__" + occasionName;
  let items = [];
  try {
    const raw = localStorage.getItem(key);
    items = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(items)) items = [];
  } catch {
    items = [];
  }
  const exists = items.some((x) => String(x.id) === String(item.id));
  if (!exists) items.unshift(item);
  localStorage.setItem(key, JSON.stringify(items));

  if (document.querySelector("[data-gg-giftlist-page]")) {
    // Add the new card directly to the DOM without full re-render
    const grid = document.querySelector(".gg-giftlist-grid");
    if (grid) {
      const isPurchased = window.ggPurchasedCache && window.ggPurchasedCache.has(String(item.id));
      const img = item.image
        ? `<img class="gg-giftlist-img" src="${item.image}" alt="${item.title}" loading="lazy">`
        : `<div class="gg-giftlist-img gg-giftlist-img--placeholder"></div>`;
      const chosenTag = isPurchased ? `<div class="gg-gift-chosen-tag">Gift chosen</div>` : '';
      const card = document.createElement('div');
      card.className = `gg-giftlist-card${isPurchased ? ' is-purchased' : ''}`;
      card.setAttribute('data-item-id', item.id);
      card.innerHTML = `
        <a class="gg-giftlist-link" href="${item.url}">
          <div style="position:relative">
            ${img}
            ${chosenTag}
          </div>
          <div class="gg-giftlist-meta">
            <div class="gg-giftlist-title">${item.title}</div>
            ${item.price ? `<div class="gg-giftlist-price">${item.price}</div>` : ''}
          </div>
        </a>
        <button
          class="gg-giftlist-remove"
          type="button"
          data-gg-remove
          aria-label="Remove from gift ideas"
          data-product-id="${item.id}"
          data-product-handle="${item.handle}"
          data-product-title="${item.title}"
          data-product-url="${item.url}"
          data-product-image="${item.image}"
          data-product-price="${item.price}"
        >
          Remove
        </button>
      `;
      grid.prepend(card);
    } else {
      // No grid yet — do a full render (empty state was showing)
      window.renderGiftListPage();
    }
  }
  if (window.ggRenderOccasionsFromStorage) window.ggRenderOccasionsFromStorage();
  if (window.ggUpdateAllHeartStates) window.ggUpdateAllHeartStates();

  if (typeof ggToast === "function") {
    ggToast("Saved to " + occasionName + " ✓", "success");
  }

  // Auto-save to Supabase immediately
  if (window.ggCustomer?.id) {
    (async function() {
      try {
        const savedMeta = (() => { try { return JSON.parse(localStorage.getItem(`gg_occasion_meta__${occasionName}`) || "{}"); } catch { return {}; } })();
        const shareCode = localStorage.getItem(`gg_share_code__${occasionName}`) || localStorage.getItem('gg_share_code');

        let remoteItems = [];
        if (shareCode) {
          // Fetch current list from Supabase to preserve purchased states
          const getRes = await fetch(
            `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(shareCode)}`,
            { headers: { apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M", Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M` } }
          );
          const getData = await getRes.json();
          const payload = getData?.list || getData || {};
          remoteItems = payload.items || [];
          if (typeof remoteItems === 'string') { try { remoteItems = JSON.parse(remoteItems); } catch(e) { remoteItems = []; } }
        }

        // Build purchased map from Supabase
        const purchasedMap = new Map(
          (Array.isArray(remoteItems) ? remoteItems : []).map(i => [String(i.id || ""), !!i.purchased])
        );

        // Add new item (not purchased) and preserve all existing purchased states
        const newItem = {
          id: String(item.id || ""),
          title: item.title || "",
          url: item.url || "",
          image: item.image || "",
          price: item.price || "",
          handle: item.handle || "",
          purchased: false
        };

        const updatedItems = [newItem, ...remoteItems.map(i => ({
          id: String(i.id || ""),
          title: i.title || "",
          url: i.url || "",
          image: i.image || "",
          price: i.price || "",
          handle: i.handle || "",
          purchased: !!purchasedMap.get(String(i.id || ""))
        }))].filter((i, idx, arr) => arr.findIndex(x => x.id === i.id) === idx);

        const saveRes = await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M`
          },
          body: JSON.stringify({
            title: occasionName.replace(/[\u2018\u2019]/g, "'"),
            event_date: savedMeta.occasion_date || null,
            occasion_type: savedMeta.occasion_type || "",
            occasion_date: savedMeta.occasion_date || null,
            items: updatedItems,
            child_name: savedMeta.child_name || null,
            child_dob: savedMeta.child_dob || null,
            child_pronoun: savedMeta.child_pronoun || "they",
            child_interests: savedMeta.child_interests || null,
            child_note: savedMeta.child_note || null,
            list_id: localStorage.getItem(`gg_list_id__${occasionName}`) || null,
            share_code: localStorage.getItem(`gg_share_code__${occasionName}`) || null,
            owner_token: localStorage.getItem(`gg_owner_token__${occasionName}`) || null,
            owner_customer_id: window.ggCustomer.id,
            owner_email: window.ggCustomer.email || null
          })
        });
        const saveData = await saveRes.json();
        if (saveData.share_code) {
          localStorage.setItem(`gg_share_code__${occasionName}`, saveData.share_code);
          localStorage.setItem(`gg_owner_token__${occasionName}`, saveData.owner_token || "");
          localStorage.setItem(`gg_list_id__${occasionName}`, saveData.id || "");
        }
      } catch(err) {
        console.log("Direct add save failed", err);
      }
    })();
  }
}

      // Delete occasion from modal
document.addEventListener("click", (e) => {
  const del = e.target.closest("[data-gg-occasion-delete]");
  if (!del) return;

  e.preventDefault();
  e.stopPropagation();

  const name = del.getAttribute("data-gg-occasion-delete");
  if (!name) return;

  if (!window.confirm(`Delete "${name}"? This will remove its list too.`)) return;

  const occasions = ggLoadOccasions().filter((x) => x !== name);
  ggSaveOccasions(occasions);

  // Get the list ID before removing from localStorage
  const listId = localStorage.getItem(`gg_list_id__${name}`);

  localStorage.removeItem("gg_giftlist_v1__" + name);
  localStorage.removeItem("gg_share_code__" + name);
  localStorage.removeItem("gg_list_id__" + name);
  localStorage.removeItem("gg_owner_token__" + name);
  localStorage.removeItem("gg_occasion_meta__" + name);

  // Also track deleted list titles so sync doesn't restore them
  const deleted = JSON.parse(localStorage.getItem("gg_deleted_occasions_v1") || "[]");
  const normName = name.replace(/[\u2018\u2019]/g, "'");
  if (!deleted.includes(normName)) {
    deleted.push(normName);
    localStorage.setItem("gg_deleted_occasions_v1", JSON.stringify(deleted));
  }

  // Delete from Supabase
  if (listId && window.ggCustomer?.id) {
    fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-delete-list", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M`
      },
      body: JSON.stringify({
        list_id: listId,
        owner_customer_id: window.ggCustomer.id
      })
    }).catch(err => console.log("Delete from Supabase failed:", err));
  }

  const active = ggLoadActiveOccasion();
  if (active === name) {
    const nextActive = occasions[0] || "";
    ggSaveActiveOccasion(nextActive);
  }

  ggRenderOccasionsFromStorage();

  if (typeof renderGiftListPage === "function") {
    renderGiftListPage();
  }

  if (typeof ggToast === "function") {
    ggToast(`Deleted ${name}`, "success");
  }
});

// Share occasion card + edit occasion
document.addEventListener("click", (e) => {
  const share = e.target.closest(".gg-occasion-card__share");
  if (share) {
    e.preventDefault();
    e.stopPropagation();

    const name = share.getAttribute("data-gg-occasion-share");
    if (!name) return;

if (!window.ggCustomer?.id) {
  const returnUrl = encodeURIComponent(window.location.pathname);
  // Save the list anonymously before redirecting so it survives login
  if (typeof window.saveListToCustomer === "function") {
    window.saveListToCustomer().finally(() => {
      window.location.href = "/customer_authentication/login?return_to=" + returnUrl;
    });
  } else {
    window.location.href = "/customer_authentication/login?return_to=" + returnUrl;
  }
  return;
}
    const shareCode =
      localStorage.getItem(`gg_share_code__${name}`) ||
      localStorage.getItem("gg_share_code");

    if (!shareCode) {
      window.saveListToCustomer().then((data) => {
        const freshShareCode =
          data?.share_code ||
          localStorage.getItem(`gg_share_code__${name}`) ||
          localStorage.getItem("gg_share_code");

        if (!freshShareCode) return;

        const url = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(freshShareCode)}&occasion=${encodeURIComponent(name)}`;

        const panel = document.querySelector("[data-gg-share-panel]");
const input = document.querySelector("[data-gg-share-url]");
const nativeBtn = document.querySelector("[data-gg-native-share]");
const titleEl = document.querySelector("[data-gg-share-title]");
const textEl = document.querySelector("[data-gg-share-text]");

if (input) input.value = url;
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = !navigator.share;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(name)}`;
      });

      return;
    }

    const url = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(shareCode)}&occasion=${encodeURIComponent(name)}`;

   const panel = document.querySelector("[data-gg-share-panel]");
const input = document.querySelector("[data-gg-share-url]");
const nativeBtn = document.querySelector("[data-gg-native-share]");
const titleEl = document.querySelector("[data-gg-share-title]");
const textEl = document.querySelector("[data-gg-share-text]");

if (input) input.value = url;
navigator.clipboard.writeText(url).catch(() => {});
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = !navigator.share;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(name)}`;

    return;
  }

});

        // close modal
        document.addEventListener("click", (e) => {
          if (e.target.closest("[data-gg-modal-close]")) {
            ggCloseModal();
          }
        });

        document.addEventListener("click", function (e) {
  const openBtn = e.target.closest("#gg-open-create-modal");
  if (!openBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const modal = document.getElementById("gg-create-modal");
  if (!modal) return;

  modal.hidden = false;
  document.body.classList.add("overflow-hidden");
});

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest("#gg-close-create-modal");
  const backdrop = e.target === document.getElementById("gg-create-modal");

  if (!closeBtn && !backdrop) return;

  const modal = document.getElementById("gg-create-modal");
  if (!modal) return;

  modal.hidden = true;
  document.body.classList.remove("overflow-hidden");
});

      // show create occasion form
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-toggle]");
        if (!btn) return;
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");
      if (confirmBox) confirmBox.hidden = true;

        const form = document.querySelector("[data-gg-modal-create-form]");
        const input = document.querySelector("[data-gg-modal-create-input]");
        if (!form || !input) return;

        form.hidden = false;
        input.value = "";
        input.focus();
      });

      // cancel create
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-cancel]");
        if (!btn) return;

        const form = document.querySelector("[data-gg-modal-create-form]");
        if (form) form.hidden = true;
      });

      // save new occasion
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-save]");
        if (!btn) return;

        const input = document.querySelector("[data-gg-modal-create-input]");
        if (!input) return;

        const name = input.value.trim();
        if (!name) return;

        const list = ggLoadOccasions();

        if (!list.includes(name)) {
          list.unshift(name);
          ggSaveOccasions(list);
        }

        ggSaveActiveOccasion(name);
        const createForm = document.querySelector("[data-gg-modal-create-form]");
      const createInput = document.querySelector("[data-gg-modal-create-input]");
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");

      if (createInput) createInput.value = "";
      if (createForm) createForm.hidden = true;
      if (confirmBox) confirmBox.hidden = true;

        if (pendingItem) {
          ggAddItemToOccasion(pendingItem, name);
          ggCloseModal();
        }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }
      });

    })();
      function escapeHtml(str) {
        return String(str || "").replace(/[&<>"']/g, (s) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        }[s]));
      }

      /* =========================================================
        SHARE LIST
      ========================================================= */

      (function () {

  if (window.__GG_GIFTLIST_SHARE_INIT__) return;
  window.__GG_GIFTLIST_SHARE_INIT__ = true;

        function getShareUrl() {
          const shareCode = localStorage.getItem("gg_share_code");
          if (!shareCode) return "";

          return `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(shareCode)}`;
        } 

        async function copyShareLink() {
  const input = document.querySelector("[data-gg-share-url]");
  const shareUrl = input?.value?.trim() || getShareUrl();

          if (!shareUrl) {
            ggToast("Save your list first", "error");
            return;
          }

          try {
            await navigator.clipboard.writeText(shareUrl);
            ggToast("Share link copied ✓", "success");
          } catch (err) {
            console.log("Share copy failed ❌", err);
            ggToast("Could not copy link", "error");
          }
        }

        document.addEventListener("click", function (e) {
          const whatsappBtn = e.target.closest("[data-gg-share-whatsapp]");
if (whatsappBtn) {
  e.preventDefault();
  e.stopPropagation();

  const shareUrl = getShareUrl();
  if (!shareUrl) {
    ggToast("Save your list first", "error");
    return;
  }

  const text = encodeURIComponent(`Here are a few gift ideas I've put together: ${shareUrl}`);
  window.open(`https://wa.me/?text=${text}`, "_blank");
  return;
}
          const copyBtn = e.target.closest("[data-gg-copy-share-link]");
          if (copyBtn) {
          e.preventDefault();
          e.stopPropagation();
          copyShareLink();
          return;
          }
          const btn = e.target.closest("[data-gg-share-list]");
          if (!btn) return;

          e.preventDefault();
          e.stopPropagation();

          (async function () {
  const result = await window.saveListToCustomer();
  console.log("Share result:", result);

  if (!result || !result.share_code) {
    return;
  }

  const shareUrl = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(result.share_code)}`;

  const panel = document.querySelector("[data-gg-share-panel]");
  const input = document.querySelector("[data-gg-share-url]");
  const nativeBtn = document.querySelector("[data-gg-native-share]");
  const titleEl = document.querySelector("[data-gg-share-title]");
  const textEl = document.querySelector("[data-gg-share-text]");

  if (input) input.value = shareUrl;
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = true;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(localStorage.getItem("gg_active_occasion_v1") || "this occasion")}`;
})();
        });
        })();

      /* =========================================================
        LOAD SHARED LIST PAGE
      ========================================================= */

      (function () {
        async function loadSharedList() {
          const root = document.querySelector("[data-gg-shared-giftlist-root]");
          if (!root) return;

          const params = new URLSearchParams(window.location.search);
          const code = params.get("code");

          if (!code) {
            root.innerHTML = "<p>No gift list found.</p>";
            return;
          }

          try {
          
          const res = await fetch(
        `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(code)}`,
          {
          headers: {
            apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
            Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
          },
        }
      );

            const data = await res.json();

            console.log("SHARED LIST DATA:", data);
            const payload = data?.list || data || {};

let items =
  payload.items ||
  payload.products ||
  payload.list_items ||
  payload.gift_ideas ||
  payload.ideas ||
  [];

if (typeof items === "string") {
  try {
    items = JSON.parse(items);
  } catch (err) {
    items = [];
  }
}

if (!Array.isArray(items) && typeof items === "object" && items !== null) {
  items =
    items.items ||
    items.products ||
    items.list_items ||
    [];
}

if (!Array.isArray(items)) {
  items = [];
}

      const title = payload.title || "";
      const childName = payload.child_name || "";
      const childDob = payload.child_dob || "";
      const childPronoun = payload.child_pronoun || "they";
      const childInterests = payload.child_interests || "";
      const childNote = payload.child_note || "";
      const occasionDate = payload.occasion_date || payload.event_date || "";
      const occasionType = payload.occasion_type || "";

console.log("NORMALIZED PAYLOAD:", payload);
console.log("NORMALIZED ITEMS:", items);
console.log("PAYLOAD KEYS:", Object.keys(payload || {}));

          // Build shared page hero
const hero = document.querySelector("[data-gg-shared-hero]");

if (hero) {
  const name = childName?.trim() || title || "Gift ideas";
  const rawInterests = childInterests || "";
  const note = childNote || "";
  const dob = childDob;
  const pronoun = (childPronoun || "they").toLowerCase();
  const occasionDate = payload.event_date || "";

  const interestsArray = rawInterests
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);

  let interestsText = "";
  if (interestsArray.length === 1) {
    interestsText = interestsArray[0];
  } else if (interestsArray.length === 2) {
    interestsText = `${interestsArray[0]} and ${interestsArray[1]}`;
  } else if (interestsArray.length > 2) {
    interestsText = `${interestsArray.slice(0, -1).join(", ")} and ${interestsArray[interestsArray.length - 1]}`;
  }

  let subject = "They";
  let subjectContracted = "They’re";

  if (pronoun === "she") {
    subject = "She";
    subjectContracted = "She’s";
  } else if (pronoun === "he") {
    subject = "He";
    subjectContracted = "He’s";
  }

  let occasionLine = "";

  if (dob && occasionDate) {
    const birth = new Date(dob);
    const occ = new Date(occasionDate);

    let age = occ.getFullYear() - birth.getFullYear();
    const m = occ.getMonth() - birth.getMonth();

    if (m < 0 || (m === 0 && occ.getDate() < birth.getDate())) {
      age--;
    }

    const formattedDate = occ.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long"
    });

    if (occasionType && occasionType.toLowerCase() === "birthday") {
      occasionLine = `${name}’s ${age}${getOrdinal(age)} birthday • ${formattedDate}`;
    } else if (occasionType) {
      occasionLine = `${occasionType} • ${formattedDate}`;
    } else {
      occasionLine = formattedDate;
    }
  } else if (occasionType) {
    occasionLine = occasionType;
  }

const tagsHTML = "";

  const interestsLine = interestsText
    ? `<p class="gg-shared-intro">${subjectContracted} currently really into ${interestsText}.</p>`
    : "";

  const noteLine = note
    ? `<p class="gg-shared-note"><strong>Helpful note:</strong> ${note}</p>`
    : "";

  hero.innerHTML = `
    <h1 class="gg-shared-title">${childName ? `${name}'s gift ideas` : title}</h1>
    ${occasionLine ? `<p class="gg-shared-occasion">${occasionLine}</p>` : ""}
    <p class="gg-shared-intro">
      ${childName
        ? `If you're looking for a gift for ${name}, here are a few ideas they would really love.`
        : `Here are a few gift ideas they would love.`}
    </p>
    ${interestsLine}
    ${tagsHTML}
    ${noteLine}
  `;
}

            const cards = items
        .map((item) => {
          return `
        <div class="gg-giftlist-card ${item.purchased ? "is-purchased" : ""}" data-item-id="${item.id}" data-price="${parseFloat((item.price || "0").toString().replace(/[^0-9.]/g, '')) || 0}">
          <a class="gg-giftlist-link" href="${item.url}" target="_blank" rel="noopener noreferrer">
            <img class="gg-giftlist-img" src="${item.image}" alt="${item.title}" loading="lazy">
            <div class="gg-giftlist-meta">
              <div class="gg-giftlist-title">${item.title}</div>
              <div class="gg-giftlist-price">${item.price || ""}</div>
            </div>
          </a>

          <a class="gg-buy-btn" href="/products/${item.handle}">
            Buy from retailer
          </a>

          <div class="gg-purchase-actions">
            <button 
              class="gg-purchased-btn ${item.purchased ? "is-purchased" : ""}" 
              type="button"
              data-product-handle="${item.handle}"
            >
              ${item.purchased ? "✓ Someone is buying this" : "I'll buy this"}
            </button>
          </div>
        </div>
      `;
        })
        .join("");

            root.innerHTML = `<div class="gg-giftlist-grid" data-gg-shared-grid>${cards}</div>`;
            sortGiftCards();
          } catch (err) {
            console.log("Error loading shared list", err);
            root.innerHTML = "<p>Could not load gift list.</p>";
          }
        }

            function getOrdinal(n) {
        if (n % 10 === 1 && n % 100 !== 11) return "st";
        if (n % 10 === 2 && n % 100 !== 12) return "nd";
        if (n % 10 === 3 && n % 100 !== 13) return "rd";
        return "th";
      }

      function applySharedPriceFilters() {
        const activeButtons = Array.from(document.querySelectorAll(".gg-filter-btn.active"));
        const cards = document.querySelectorAll(".gg-giftlist-card");

        if (!activeButtons.length) {
          cards.forEach((card) => {
            card.style.display = "";
          });
          return;
        }

        const activeRanges = activeButtons.map((btn) => {
          const range = btn.dataset.priceFilter || "";
          const [min, max] = range.split("-").map(Number);
          return { min, max };
        });

        cards.forEach((card) => {
          const price = parseFloat(card.dataset.price || "0");

          const matchesAnyRange = activeRanges.some(({ min, max }) => {
            return price >= min && price <= max;
          });

          card.style.display = matchesAnyRange ? "" : "none";
        });
      }

      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".gg-filter-btn");
        if (!btn) return;

        btn.classList.toggle("active");
        applySharedPriceFilters();
      });

      document.addEventListener("click", function (e) {
        const clearBtn = e.target.closest(".gg-filter-clear");
        if (!clearBtn) return;

        document.querySelectorAll(".gg-filter-btn").forEach((btn) => {
          btn.classList.remove("active");
        });

        applySharedPriceFilters();
      });

      function sortGiftCards() {
  const grid = document.querySelector("[data-gg-shared-grid]");
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll(".gg-giftlist-card"));
  const select = document.querySelector("#gg-sort");

  cards.sort((a, b) => {
    if (select && select.value) {
      const priceA = parseFloat(a.dataset.price || "0");
      const priceB = parseFloat(b.dataset.price || "0");

      if (select.value === "price-low") return priceA - priceB;
      if (select.value === "price-high") return priceB - priceA;
    }

    const aPurchased = a.classList.contains("is-purchased");
    const bPurchased = b.classList.contains("is-purchased");

    if (aPurchased && !bPurchased) return 1;
    if (!aPurchased && bPurchased) return -1;

    return 0;
  });

  cards.forEach((card) => grid.appendChild(card));
      }

      document.addEventListener("change", function (e) {
        if (e.target.matches("#gg-sort")) {
          sortGiftCards();
        }
      });

      document.addEventListener("click", async function (e) {
        const primaryBtn = e.target.closest(".gg-purchased-btn");

        if (!primaryBtn) return;

        const clickedBtn = primaryBtn;

        const card = clickedBtn.closest(".gg-giftlist-card");
        if (!card) return;

        const itemId = card.dataset.itemId;
        const params = new URLSearchParams(window.location.search);
        const shareCode = params.get("code");

        const nextPurchased = !card.classList.contains("is-purchased");

        const primaryActionBtn = card.querySelector(".gg-purchased-btn:not([data-gg-bought-elsewhere])");
        const elsewhereActionBtn = card.querySelector("[data-gg-bought-elsewhere]");

        card.classList.toggle("is-purchased", nextPurchased);

if (primaryActionBtn) {
  primaryActionBtn.classList.toggle("is-purchased", nextPurchased);
  primaryActionBtn.textContent = nextPurchased ? "✓ Someone is buying this" : "I'll buy this";
}


        // Navigate to product page after marking as purchased
        if (nextPurchased) {
          const handle = primaryBtn.dataset.productHandle;
          if (handle) {
            setTimeout(function() {
              window.location.href = "/products/" + handle;
            }, 800);
          }
        }

        try {
          const res = await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-update-purchased", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              share_code: shareCode,
              item_id: itemId,
              purchased: nextPurchased
            })
          });

          if (!res.ok) {
            throw new Error("Failed to save purchased status");
          }
        } catch (err) {
          console.log("Failed to update purchased status", err);

          card.classList.toggle("is-purchased", !nextPurchased);

if (primaryActionBtn) {
  primaryActionBtn.classList.toggle("is-purchased", !nextPurchased);
  primaryActionBtn.textContent = !nextPurchased ? "✓ Someone is buying this" : "I'll buy this";
}

          alert("Sorry, that change could not be saved.");
        }
      });

      document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("[data-gg-create-form]");

  setTimeout(() => {
  if (typeof sortGiftCards === "function") {
    sortGiftCards();
  }
}, 100);

  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const message = document.querySelector("[data-gg-create-message]");
    if (message) {
      message.hidden = true;
      message.textContent = "";
    }

    const childName = document.querySelector("[data-child-name]")?.value?.trim() || "";
    const childDob = document.querySelector("[data-child-dob]")?.value || null;
    const childPronoun = document.querySelector("[data-child-pronoun]")?.value || "they";
    const childInterests = document.querySelector("[data-child-interests]")?.value?.trim() || "";
    const childNote = document.querySelector("[data-child-note]")?.value?.trim() || "";
    const occasionType = document.querySelector("[data-occasion-type]")?.value || "";
    const occasionDate = document.querySelector("[data-occasion-date]")?.value || null;
    let occasionTitle = document.querySelector("[data-occasion-title]")?.value?.trim() || "";

    if (!childName || !occasionType) {
      if (message) {
        message.hidden = false;
        message.textContent = "Please add a child’s name and choose an occasion.";
      }
      return;
    }

    if (!occasionTitle) {
      if (occasionType === "Birthday") {
        occasionTitle = `${childName}'s Birthday`;
      } else if (occasionType === "Christmas") {
        occasionTitle = `Christmas`;
      } else {
        occasionTitle = `${childName}'s occasion`;
      }
    }

    const occasions = ggLoadOccasions();

    if (!occasions.includes(occasionTitle)) {
      occasions.unshift(occasionTitle);
      ggSaveOccasions(occasions);
    }

    ggSaveActiveOccasion(occasionTitle);

    if (!localStorage.getItem("gg_giftlist_v1__" + occasionTitle)) {
      localStorage.setItem("gg_giftlist_v1__" + occasionTitle, "[]");
    }

    if (window.ggRenderOccasionsFromStorage) {
      window.ggRenderOccasionsFromStorage();
    }

    if (typeof renderGiftListPage === "function") {
      renderGiftListPage();
    }

    try {
      const FUNCTION_URL = "https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list";

      // ... keep the rest of your existing save code here ...
      
      const activeKey = "gg_giftlist_v1__" + occasionTitle;

let items = [];
try {
  const rawItems = localStorage.getItem(activeKey);
  items = rawItems ? JSON.parse(rawItems) : [];
  if (!Array.isArray(items)) items = [];
} catch (err) {
  items = [];
}

console.log("RAW ITEMS BEFORE CLEAN:", items);
console.log("RAW ITEM COUNT:", items?.length);

const existingPurchasedMap = new Map(
  (JSON.parse(localStorage.getItem("gg_last_saved_items") || "[]") || []).map((saved) => [
    String(saved.id || ""),
    !!saved.purchased
  ])
);

const cleanItems = items
  .map((item) => ({
    id: String(item.id || ""),
    title: item.title || "",
    url: item.url || "",
    image: item.image || "",
    price: item.price || "",
    handle: item.handle || "",
    purchased:
      typeof item.purchased !== "undefined"
        ? !!item.purchased
        : !!existingPurchasedMap.get(String(item.id || ""))
  }))
  .filter((item) => item.id && item.title && item.url);

    console.log("CLEAN ITEMS:", cleanItems);
    console.log("CLEAN ITEM COUNT:", cleanItems.length);

              console.log("CREATE FORM payload:", {
          title: occasionTitle,
          event_date: occasionDate,
          occasion_type: occasionType,
          occasion_date: occasionDate,
          items: cleanItems,
          child_name: childName,
          child_dob: childDob,
          child_pronoun: childPronoun,
          child_interests: childInterests,
          child_note: childNote
        });

        const res = await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
                Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
              },
              body: JSON.stringify({
                title: occasionTitle,
                event_date: occasionDate,
                occasion_type: occasionType,
                occasion_date: occasionDate,
                items: cleanItems,
                child_name: childName,
                child_dob: childDob,
                child_pronoun: childPronoun,
                child_interests: childInterests,
                child_note: childNote,
                owner_customer_id: window.ggCustomer?.id || null,
                owner_email: window.ggCustomer?.email || null
              }),
            });

            const raw = await res.text();
      console.log("Create gift ideas raw response:", raw);

      let data = {};
      try {
        data = JSON.parse(raw);
      } catch (e) {
        data = {};
      }

      console.log("Create gift ideas parsed response:", data);

      if (!res.ok) {
        throw new Error(data?.error || raw || "Could not create gift ideas.");
      }

            if (!data || !data.share_code) {
              throw new Error("No share code returned.");
            }

            localStorage.setItem("gg_list_id", data.id || "");
localStorage.setItem("gg_owner_token", data.owner_token || "");
localStorage.setItem("gg_share_code", data.share_code || "");

localStorage.setItem(`gg_list_id__${occasionTitle}`, data.id || "");
localStorage.setItem(`gg_owner_token__${occasionTitle}`, data.owner_token || "");
localStorage.setItem(`gg_share_code__${occasionTitle}`, data.share_code || "");

const mappedInterests = ggMapInterests(childInterests);

localStorage.setItem(
  `gg_occasion_meta__${occasionTitle}`,
  JSON.stringify({
    child_name: childName,
    child_dob: childDob,
    child_interests: childInterests,
    child_interests_mapped: mappedInterests,
    occasion_type: occasionType,
    occasion_date: occasionDate
  })
);

console.log("Stored occasion meta locally:", occasionTitle, {
  child_name: childName,
  child_dob: childDob,
  child_pronoun: childPronoun,
  child_interests: childInterests,
  child_note: childNote,
  occasion_type: occasionType,
  occasion_date: occasionDate
});
      const modal = document.getElementById("gg-create-modal");
      if (modal) {
        modal.hidden = true;
      }
          const browseUrl = ggBuildBrowseUrl(occasionTitle);
          window.location.href = browseUrl;
          } catch (err) {
        console.log("Create gift ideas failed ❌", err);
        alert("Create gift ideas failed. Open Console to see the error.");
        if (message) {
          message.hidden = false;
          message.textContent = "Sorry, something went wrong while creating your gift ideas.";
        }
      }
        });
      });

        document.addEventListener("DOMContentLoaded", loadSharedList);
      })();

      document.addEventListener("DOMContentLoaded", function () {
        const openBtn = document.getElementById("gg-open-create-modal");
        const modal = document.getElementById("gg-create-modal");
        const closeBtn = document.getElementById("gg-close-create-modal");

        if (openBtn && modal) {
          openBtn.addEventListener("click", () => {
            modal.hidden = false;
          });
        }

        if (closeBtn && modal) {
          closeBtn.addEventListener("click", () => {
            modal.hidden = true;
          });
        }

        if (modal) {
          modal.addEventListener("click", (e) => {
            if (e.target === modal) {
              modal.hidden = true;
            }
          });
        }
      });

      // Close share modal
document.addEventListener("click", function (e) {
  const panel = document.querySelector("[data-gg-share-panel]");
  if (!panel || panel.hidden) return;

  const clickedClose = e.target.closest("[data-gg-share-close]");
  const clickedInsideDialog = e.target.closest(".gg-share-modal__dialog");

  if (clickedClose) {
    panel.hidden = true;
    return;
  }

  if (!clickedInsideDialog && e.target.closest("[data-gg-share-panel]")) {
    panel.hidden = true;
  }
});